import React from 'react';
import SEO from './SEO';
import Container from './ui/Container';

const ConsumerArea = () => {
  return (
    <div className="consumer-area">
      <SEO
        title="Consumer Area - Data Privacy & Rights - Lloyd James Media"
        description="Learn about your data privacy rights and how Lloyd James Media handles consumer information. Transparent data practices and consumer control over personal data."
        keywords="consumer data rights, data privacy, personal information, consumer area, data protection, Lloyd James"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://www.lloydjames.com'}/consumer-area`}
      />
      <Container>
        <h1 className="consumer-title">Consumer Area</h1>
        <div className="consumer-subtitle">
          <p>
            Welcome to the Consumer Area. This section provides information and resources 
            specifically designed for consumers who want to understand how their data is used 
            and managed by Lloyd James Data Consultancy.
          </p>
          <p>
            We are committed to transparency and ensuring that consumers have full control 
            over their personal information. Here you can find details about our data practices, 
            your rights as a consumer, and how to manage your preferences.
          </p>
        </div>
      </Container>
      
      {/* Consumer Contact Section */}
      <div className="consumer-contact-section">
        <Container>
          <h2>Get in Touch</h2>
          <p>
            If you have any questions about how we handle your data or would like to 
            exercise your consumer rights, please don't hesitate to contact us.
          </p>
          <address>
            <strong>Lloyd James Data Consultancy</strong><br />
            Email: <a href="mailto:info@lloydjames.co.uk">info@lloydjames.co.uk</a><br />
            Phone: <a href="tel:+441234567890">+44 123 456 7890</a>
          </address>
        </Container>
      </div>
    </div>
  );
};

export default ConsumerArea;